<template>
    <div v-loading="loading">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>发货单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed">
            <span>卖家信息</span>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row align-left">
                <th class="align-left">卖家名称</th>
                <th style="width: 200px">发货人</th>
                <th style="width: 200px">发货人联系方式</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row align-left">
                <td class="align-left ellipsis" :title="goodsShipVoucher.sellerName">{{goodsShipVoucher.sellerName}}</td>
                <td style="width: 200px">{{goodsShipVoucher.senderContactName}}</td>
                <td style="width: 200px">{{goodsShipVoucher.senderContactTel}}</td>
            </tr>
            </tbody>
        </table>
        <div class="content-caption dashed">
            <span>零售机构信息</span>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row align-left">
                <th style="width: 200px; text-align: left">业务单元</th>
                <th style="width: 200px; text-align: left">所属部门</th>
                <th>收货地址</th>
                <th style="width: 200px">联系人</th>
                <th style="width: 200px">联系方式</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row align-left">
                <td style="width: 200px; text-align: left" class="ellipsis" :title="goodsShipVoucher.buyerShopName">
                    <span>{{goodsShipVoucher.buyerShopName}}</span>
                </td>
                <td style="width: 200px; text-align: left" class="ellipsis" :title="goodsShipVoucher.buyerBizUnitName">
                    <span>{{goodsShipVoucher.buyerBizUnitName}}</span>
                </td>
                <td class="ellipsis" :title="goodsShipVoucher.buyerRecvAddr">{{goodsShipVoucher.buyerRecvAddr}}</td>
                <td style="width: 200px">{{goodsShipVoucher.buyerRecvContractName}}</td>
                <td style="width: 200px">{{goodsShipVoucher.buyerRecvContactTel}}</td>
            </tr>
            </tbody>
        </table>
        <div class="content-caption dashed">
            <span>商品信息</span>
        </div>
        <div class="table-layout">
            <el-form :model="goodsShipVoucher" ref="goods">
                <el-table :data="goodsShipVoucher.itemList" border style="width: 100%" maxHeight="400" :summary-method="getDoodsShipVoucher" show-summary>

                    <el-table-column align="center" label="资产信息" v-if="showAssetInfo">
                        <el-table-column align="left" width="130" prop="devcName" label="名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="devcCatName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="devcBrandName" label="品牌" show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column align="center" label="商品信息" v-if="showAssetInfo">
                        <el-table-column align="left" width="130" prop="title" label="名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" width="160" label="需要供应商提供唯一标识码">
                            <template slot-scope="rows">
                                <span v-if="rows.row.vendorUknoFlag">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="60" prop="setupFlag" label="需要安装">
                            <template slot-scope="rows">
                                <span v-if="rows.row.setupFlag">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="80" prop="asmblFlag" label="含组装商品">
                            <template slot-scope="rows">
                                <span v-if="rows.row.asmblFlag">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="60" prop="asmblFlag" label="组装件">
                            <template slot-scope="rows">
                                <span v-if="rows.row.asmblAccFlag">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="asmblFlag" label="安装时完成组装">
                            <template slot-scope="rows">
                                <span v-if="rows.row.asmblWhileSetup">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="price" label="含税价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="taxRate" label="税率(%)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.taxRate != null">{{rows.row.taxRate.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="ntxPrice" label="未税价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="150" prop="amount" label="费用小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.amount != null">{{rows.row.amount.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="150" prop="ntxAmount" label="未税小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxAmount != null">{{rows.row.ntxAmount.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="quantity" label="发货数量">
                            <template slot-scope="rows">
                                <span>{{(rows.row.quantity || 0) - (rows.row.offsetQuantity || 0)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="recvQuantity" label="收货数量">
                            <template slot-scope="rows">
                                <span>{{rows.row.recvQuantity || 0}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="desc" label="说明" show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column align="left" prop="title" label="名称" width="150" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="left" width="120" prop="catName" label="分类" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="left" width="100" prop="brandName" label="品牌" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="center" width="160" label="需要供应商提供唯一标识码" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.vendorUknoFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="60" prop="setupFlag" label="需要安装" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.setupFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="80" prop="asmblFlag" label="含组装商品" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.asmblFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="60" prop="asmblFlag" label="组装件" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.asmblAccFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="100" prop="asmblFlag" label="安装时完成组装" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.asmblWhileSetup">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100" prop="price" label="含税价(元)" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100" prop="taxRate" label="税率(%)" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.taxRate != null">{{rows.row.taxRate.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100" prop="ntxPrice" label="未税价(元)" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="150" prop="amount" label="费用小计(元)" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.amount != null">{{rows.row.amount.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="150" prop="ntxAmount" label="未税小计(元)" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span v-if="rows.row.ntxAmount != null">{{rows.row.ntxAmount.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100" prop="quantity" label="发货数量" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span>{{(rows.row.quantity || 0) - (rows.row.offsetQuantity || 0)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100" prop="recvQuantity" label="收货数量" v-if="!showAssetInfo">
                        <template slot-scope="rows">
                            <span>{{rows.row.recvQuantity || 0}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="desc" label="说明" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="rows">
                            <i class="swb-btn-link" v-if="rows.row.ukQuantity > 0" @click="showGoodsUkno(rows.row)">查看商品标识码</i>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </div>
        <div class="content-caption dashed">
            <span>物流信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>预计到货时间</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsShipVoucher.expectArriveDate || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>公司名称</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsShipVoucher.logisComName || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>公司代码</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsShipVoucher.logisComCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>司机姓名</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsShipVoucher.driverName || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>司机电话</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsShipVoucher.driverMobile || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>车辆牌号</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsShipVoucher.vehicleLsnNo || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>物流单号</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsShipVoucher.logisExpNo || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>物流费用</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsShipVoucher.logisFee || '无' }}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed" v-if="goodsShipVoucher.exceptional">
            <span>异常描述</span>
        </div>
        <div class="simple-form" v-if="goodsShipVoucher.exceptional">
            <div class="form-group center">
                <div class="form-value">
                    <span>{{goodsShipVoucher.exceptionDesc}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed" v-if="goodsShipVoucher.shipVoucherFileList != null && goodsShipVoucher.shipVoucherFileList.length > 0">
            <span>发货附件</span>
        </div>
        <div class="file-view-list" v-if="goodsShipVoucher.shipVoucherFileList != null && goodsShipVoucher.shipVoucherFileList.length > 0">
            <div class="file-view-header">
                <div class="file-name">名称</div>
                <div class="file-opera">操作</div>
            </div>
            <template v-for="(fileInfo, index) in goodsShipVoucher.shipVoucherFileList">
                <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileUuid="fileInfo.fileUuid" :deletable="false"></swb-file-item-li>
            </template>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getMerchantBizParam } from '../asset/assetMain'

    import goodsDelivApi from '../../api/goodsDeliv'
    import SwbMerchtGoodsUknoList from './MerchtGoodsUknoList'
    Vue.regist(SwbMerchtGoodsUknoList);

    export default {
        name: 'swb-goods-ship-voucher-info',
        desc: '发货单信息',
        props: ['id'],
        data: function () {
            return {
                loading: true,
                goodsShipVoucher: {},
                offsetQuantitys: [],
                showAssetInfo: false
            }
        },
        created: function () {
            this.getGoodsShipVoucher();
            let self = this;
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
        },
        methods: {
            getGoodsShipVoucher: function () {
                let self = this;
                let id = self.id;
                let filter = {};
                filter.id = id;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsShipVoucherInfo(filter, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        // console.log("fanhuijieguo==="+JSON.encode(result));
                        let goodsShipVoucher = result.data;
                        //
                        let goodsitemList = goodsShipVoucher.itemList || [];
                        self.offsetQuantitys = goodsitemList.pluck("offsetQuantity");
                        self.goodsShipVoucher = goodsShipVoucher;
                        //
                        self.loading = false;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showGoodsUkno: function (row) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: row.title + '--商品标识码查看',
                    width: 1000,
                    height: 800,
                    cancelText: '关闭',
                    showCloseBtn: true,
                    okVisible: false,
                    template: '<div>' +
                    '<swb-mercht-goods-uk-no-shop-voucher-list :itemId="itemId" ref="swb_mercht_goods_uk_no_select"></swb-mercht-goods-uk-no-shop-voucher-list>' +
                    '</div>',
                    data: {
                        itemId: row.id,
                    },
                })
            },

            // 商品信息 合计
            getDoodsShipVoucher: function (param) {
                let self = this;
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if(index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    let flag = true;
                    let quantityFlag = false;
                    let values = data.map(item => Number(item[column.property]));
                    //
                    if(column.property == 'price') {
                        values = data.map(item => Number(item['price']));
                    } else if(column.property == 'ntxPrice') {
                        values = data.map(item => Number(item['ntxPrice']));
                    } else if(column.property == 'amount') {
                        values = data.map(item => Number(item["amount"]));
                    } else if(column.property == 'ntxAmount') {
                        values = data.map(item => Number(item["ntxAmount"]));
                    } else if(column.property == 'quantity') {
                        //values = data.map(item => Number(item["quantity"]));
                        let quantitys = data.map(item => Number(item["quantity"]));
                        let datas = [];
                        for(let i = 0; i < quantitys.length; i++) {
                            let quantity = quantitys[i];
                            datas.push(quantity - self.offsetQuantitys[i]);
                        }
                        values = Utils.merge([], datas);
                        quantityFlag = true;
                    } else if(column.property == 'recvQuantity') {
                        values = data.map(item => Number(item["recvQuantity"]));
                        quantityFlag = true;
                    } else {
                        flag = false;
                    }
                    if(flag && !values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if(quantityFlag) {
                                if(!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            } else {
                                if(!isNaN(value)) {
                                    return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                                } else {
                                    return parseFloat(prev).toFixed(2);
                                }
                            }
                        }, 0);
                        if(quantityFlag) {
                            sums[index];
                        } else {
                            sums[index] += ' 元';
                        }
                    } else {
                        sums[index] = '-';
                    }
                });
                return sums;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsShipVoucherInfo.vue